import {
  bottomSheetChildrenAtom,
  bottomSheetTitleAtom,
  isBottomSheetOpenAtom,
} from '@states/uiAtoms';
import { useAtom, useSetAtom } from 'jotai';
import { ReactNode, useEffect } from 'react';

function useBottomSheet() {
  const [open, setOpen] = useAtom(isBottomSheetOpenAtom);
  const setChildren = useSetAtom(bottomSheetChildrenAtom);
  const setTitle = useSetAtom(bottomSheetTitleAtom);
  const openBottomSheet = (title: string, children: ReactNode) => {
    setTitle(title);
    setChildren(children);
    setOpen(true);
  };
  const closeBottomSheet = () => {
    setOpen(false);
  };
  useEffect(() => {
    document.body.style.overflowY = open ? 'hidden' : 'auto';
  }, [open]);
  return {
    openBottomSheet,
    closeBottomSheet,
  };
}

export default useBottomSheet;
